// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../local/lib/node_modules/expo-cli/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../local/lib/node_modules/expo-cli/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
    margin: 0;
    text-transform: uppercase;
    font-family: monospace;
    font-size: 1.625em;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: .92;
    letter-spacing: normal;
    text-align: center;
    color: #2a2c32;
}

.info {
    margin: 0;
    display: inline-block;
    font-family: monospace;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    font-size: 14px;
    letter-spacing: normal;
    color: #2a2c32;
}

.m-b-5 {
    margin-bottom: 5px;
}

.m-b-10 {
    margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./components/Style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".title {\n    margin: 0;\n    text-transform: uppercase;\n    font-family: monospace;\n    font-size: 1.625em;\n    font-weight: 500;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: .92;\n    letter-spacing: normal;\n    text-align: center;\n    color: #2a2c32;\n}\n\n.info {\n    margin: 0;\n    display: inline-block;\n    font-family: monospace;\n    font-weight: 400;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.29;\n    font-size: 14px;\n    letter-spacing: normal;\n    color: #2a2c32;\n}\n\n.m-b-5 {\n    margin-bottom: 5px;\n}\n\n.m-b-10 {\n    margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
